import type { GiantId } from '../ids/ids';

/**
 * Число заказов у гиганта по GDD (нумерованные / перечисленные позиции).
 * Индекс заказа в миссии: 0 .. count-1.
 * Ключи — GiantId v3.
 */
export const GIANT_ORDER_COUNT = {
  svami: 3,
  roza: 3,
  drakochi: 3,
  yetti: 3,
  mona: 3,
  duck: 3,
  serj: 3,
  factor: 3,
  willy: 3,
  sol: 3,
  mu: 3,
} as const satisfies Record<GiantId, number>;

export type MissionRef = {
  giantId: GiantId;
  /** Индекс заказа в каталоге гиганта, 0-based */
  orderIndex: number;
};

export type MissionValidationResult = {
  ok: boolean;
  errors: string[];
};

export function validateMissionRef(ref: MissionRef): MissionValidationResult {
  const errors: string[] = [];
  const max = GIANT_ORDER_COUNT[ref.giantId];
  if (!Number.isInteger(ref.orderIndex)) {
    errors.push('orderIndex must be an integer');
  } else if (ref.orderIndex < 0 || ref.orderIndex >= max) {
    errors.push(
      `orderIndex must be in [0, ${max}) for giant "${ref.giantId}" (GDD order list)`,
    );
  }
  return { ok: errors.length === 0, errors };
}
